import { setTrackingId } from "client/Misc/utils";
import { forwardRef, PropsWithChildren, ReactElement, Ref } from "react";
import { Portal } from "../Portal/Portal";
import styles from "./DragTooltip.module.less";

export type DragTooltipProps = {
	trackingId?: string;
};

export const DragTooltip = forwardRef<HTMLDivElement, PropsWithChildren<DragTooltipProps>>(
	(props: PropsWithChildren<DragTooltipProps>, ref: Ref<HTMLDivElement>): ReactElement => {
		const {
			trackingId,
			children
		} = props;

		return (
			<Portal
				container={document.body}
			>
				<div
					{...setTrackingId(trackingId)}
					ref={ref}
					className={styles.root}
				>
					{children}
				</div>
			</Portal>
		);
	}
);
DragTooltip.displayName="DragTooltip";